import axiosGraphQL from './GraphQL/axiosGraphQL';
const UnitApi = {
  getAllUnit: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetListUnitComboBox($input:TproductWhereInput){
    getProduct(where:$input,groupBy:[unit]){
        items{
            unit
        }
    }
}`,
      variables: {
        input: {
          unit: { not: '' },
        },
      },
    });
  },
};

export default UnitApi;
